<template>
  <div class="relative overflow-hidden">
    <LightboxVideo
      v-if="videoData"
      :video-data="videoData"
      :theme="theme"
      class="absolute left-0 top-0 h-full w-full"
    >
      <template #hidden>
        <h3>{{ title }}</h3>
        <p>{{ description }}</p>
      </template>
    </LightboxVideo>
    <figure v-else class="absolute left-0 top-0 h-full w-full overflow-hidden">
      <img
        :src="thumbnail"
        :alt="title || description"
        loading="lazy"
        class="pointer-events-none absolute left-0 top-0 block h-full w-full object-cover"
      />

      <TheMediaButton
        v-if="hasArrowButton"
        type="arrow"
        class="absolute bottom-5 right-5"
        :text="$t('card.item-button')"
        :theme="theme"
        :has-shadow="true"
      />
    </figure>
  </div>
</template>

<script setup lang="ts">
  import type { IVideoData } from '@/components/Shared/Lightbox/Video.vue';

  interface IProps {
    title: string;
    description: string;
    videoData?: IVideoData;
    thumbnail: string;
    hasArrowButton?: boolean;
    buttonText?: string;
    theme?: TTheme;
  }

  withDefaults(defineProps<IProps>(), {
    videoData: undefined,
    hasArrowButton: false,
    buttonText: '',
    theme: 'blue',
  });
</script>
